import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {WEBHOOK_URL_BASE} from '../../core/constants';
import { HttpUtils } from '../../shared/http-utils';
import {DryRunResponse, WebhookSubscription, WebhookSubscriptionEvent} from './webhook-subscription.model';
import {map} from 'rxjs/operators';

@Injectable()
export class WebhookSubscriptionService {

  private WEBHOOKS_SUBSCRIPTION_URI = 'subscriptions';

  constructor(private http: HttpClient) {}

  public getSubscriptionBySubscriberId(subscriberId: string): Observable<WebhookSubscription> {
    const headers = HttpUtils.createHeaders();
    const url = `${WEBHOOK_URL_BASE}/api/${this.WEBHOOKS_SUBSCRIPTION_URI}/subscriber/${subscriberId}`;
    return this.http.get(url, { headers })
      .pipe(map(subscription => WebhookSubscription.fromDto(subscription)));
  }

  public saveSubscription(webhookSubscription: WebhookSubscription): Observable<WebhookSubscription> {
    return webhookSubscription.id ?
      this.updateSubscription(webhookSubscription) : this.createSubscription(webhookSubscription);
  }

  private createSubscription(webhookSubscription: WebhookSubscription): Observable<WebhookSubscription> {
    const headers = HttpUtils.createHeaders();
    const url = `${WEBHOOK_URL_BASE}/api/${this.WEBHOOKS_SUBSCRIPTION_URI}`;
    return this.http.post(url, webhookSubscription, { headers })
      .pipe(map(subscription => WebhookSubscription.fromDto(subscription)));
  }

  private updateSubscription(webhookSubscription: WebhookSubscription): Observable<WebhookSubscription> {
    const headers = HttpUtils.createHeaders();
    const url = `${WEBHOOK_URL_BASE}/api/${this.WEBHOOKS_SUBSCRIPTION_URI}/${webhookSubscription.id}`;
    return this.http.put(url, webhookSubscription, { headers })
      .pipe(map(subscription => WebhookSubscription.fromDto(subscription)));
  }

  public testDryRun(webhookSuscriptionEvent: WebhookSubscriptionEvent): Observable<DryRunResponse> {
    const headers = HttpUtils.createHeaders();
    const url = `${WEBHOOK_URL_BASE}/api/${this.WEBHOOKS_SUBSCRIPTION_URI}/events/dry-run`;
    return this.http.put<DryRunResponse>(url, webhookSuscriptionEvent, { headers })
      .pipe(map(dryRunResponse => DryRunResponse.fromDto(dryRunResponse)));
  }
}
